<template>
  <right-sidebar-wrapper @close="onClose">
    <template v-slot:title>
      Starred Messages
    </template>

    <template v-slot:actions>
      <a
        class="btn btn-outline-light"
        href="#"
        data-bs-toggle="dropdown"
      >
        <i class="bx bx-dots-vertical-rounded"></i>
      </a>

      <div class="dropdown-menu dropdown-menu-end">
        <a href="#" class="dropdown-item" @click="onUnStarAll">
          <span><i class="feather-star"></i></span>
          Unstar All
        </a>
      </div>
    </template>

    <div class="chat-body">
      <div class="messages">
        <template
          v-for="(message, index) in starredMessages"
          :key="index"
        >
          <chat-message :message="message"/>
        </template>
      </div>
    </div>
  </right-sidebar-wrapper>
</template>

<script>
import AvatarImage from '@/assets/img/avatar/avatar-2.jpg';
import ChatMessage from "@/views/frontend/pages/chat/chat-message";

export default {
  components: {
    ChatMessage
  },

  data() {
    return {
      starredMessages: [
        {
          user: {
            avatar: AvatarImage,
            full_name: 'Mark Villiams',
          },
          starred: true,
          time: '20:16',
          content: 'Hello <b>@Alex</b> Thank you for the beautiful web design ahead schedule.'
        }
      ],
    };
  },

  methods: {
    onShowMessageInfo() {
      this.$eventHub.$emit('toggleThirdSidebar')
    },

    onUnStarAll() {
      //
    },

    onClose() {
      this.$eventHub.$emit('toggleSecondSidebar')
    },
  },
};
</script>
